import React, { Component } from 'react';
import {Paper, Grid, Typography, Button, IconButton, Tooltip} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
// import Settings from '@material-ui/icons/Settings';
import DatasheetView from './DatasheetView';
import moment from 'moment';
import { AssessmentOutlined } from '@material-ui/icons';
import AssessmentForm360 from './AsessementForm360';
import AssessmentFormKPI from './AsessementFormKPI';
import AssessmentFormPM from './AsessementFormPM';
import Toggle from './Toggle';
import FilterBox from './FilterBox';
import XLSX from 'xlsx';
import ExcelLogo from '../assets/ExcelLogo';
import AssessmentFormCA from './AsessementFormCA';
import AssessmentFormPA from './AsessementFormPA';
import AssessmentFormPSMA from './AsessementFormPSMA';


export default class Assessments extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: false,
            error_message: '',
            querying: true,
            nominations_array: [],
            filtered_assessments_array: [],
            filter_applied: false,
            filter_obj: {},
            create_assessment: false,
            show_all: false,
            assessment_type: '',
            assessment: {},
        }

        this.datasheetFieldSpecs = [
            { field: 'assessments', headerName: 'Assess', width: 80, headerAlign: 'center',
            sortable: false,
            renderCell: (parms) => (
                <IconButton 
                    onClick={()=>this.openAssessment(parms)} 
                >
                    <AssessmentOutlined color='primary'/>
                </IconButton>
            )},
            { field: 'store_code', headerName: 'Branch', width: 110, align:'center',headerAlign:'center'},
            { field: 'region', headerName: 'Region', width: 110, align:'center',headerAlign:'center'},
            { field: 'assessee_employee_id', headerName: 'Empl.#', width: 110, align:'center',headerAlign:'center'},
            { field: 'assessee_name', headerName: 'Assessee', width: 160},
            { field: 'job_title', headerName: 'Job Title', width: 160},
            { field: 'cycle_code', headerName: 'Cycle Code', width: 160},
            { field: 'assessment_template_id', headerName: 'Type', width: 90, align:'center',headerAlign:'center'},
            { field: 'assessment_type_id', headerName: 'By', align: 'center', headerAlign:'center', width: 80, sortable:false},
            { field: 'deadline_date', headerName: 'Deadline', width: 120},
            { field: 'reports_to_rom', headerName: 'Manager Code', align: 'center',width: 125},
        ]
    }

    componentDidMount = (show_all = false) => {

        this.setState({querying:true, filtered_assessments_array:[]});
        Gserv.sendCommand('query_my_assessments',this.props.gwt,{
            show_all : show_all
        })
        .then(reply=>{
            // console.log('query_my_assessments reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (query_pending_assessments) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (query_pending_assessments) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                
                //clean formats for display
                if (reply.Records){
                let record_array = reply.Records;
                    let deadline_date = null;
                    for (var i=0;i<record_array.length;i++){
                        deadline_date = new moment(record_array[i].deadline_date).format("YYYY-MM-DD");
                        record_array[i].deadline_date = deadline_date;
                    }
                }

                if (this.state.filter_applied){
                    this.setState({querying:false, nominations_array:reply.Records?reply.Records : []});
                    if (!reply.Records) {this.setState({filtered_assessments_array:[]})}
                    this.applyFilter(this.state.filter_obj);
                } else {
                    this.setState({querying:false, nominations_array:reply.Records?reply.Records : [], filtered_assessments_array:reply.Records?reply.Records : []});
                }
            }
        });
    };

    handleToggleChange = (e) => {
        // console.log('e :>> ', e);
        switch (e.field) {
            case 'show_all':
                this.setState({show_all:e.value});
                this.componentDidMount(e.value);
                break;

            default:
                break;
        }
    }

    resetMe = () => {
        this.setState({error: false,error_message: '',querying: true, nominations_array: [], filtered_assessments_array: []});
        this.componentDidMount(this.state.show_all);
    }

    openAssessment = (record) => {
        // console.log('record :>> ', record);
        this.setState({
            assessment:record.row,
            create_assessment:true,
            assessment_type:record.row.assessment_template_id
        });
    }

    handleChildReset = () => {
        this.setState({
            error: false,
            error_message: '',
            querying: true,
            nominations_array: [],
            filtered_assessments_array: [],
            create_assessment: false,
            assessment_type: '',
            assessment: {}
        });
        this.componentDidMount(this.state.show_all);
    }

    handleFilterChange = (filterObj) => {
        // console.log('filterObj :>> ', filterObj);
        if (filterObj.type==='clear'){
            this.setState({filtered_assessments_array : this.state.nominations_array, filter_obj: {}, filter_applied:false})
        } else {
            this.setState({filter_obj:filterObj});
            this.applyFilter(filterObj);
        }
    }

    applyFilter = (filterObj) => {
        if (this.state.nominations_array.length > 0){
            let temp_array = [];
            switch (filterObj.type) {
                case 'name':
                    for (const record of this.state.nominations_array){
                        if (record.assessee_name.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                    break;

                case 'number':
                    for (const record of this.state.nominations_array){
                        if (record.assessee_employee_id.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                    break;
 
                case 'rom':
                    for (const record of this.state.nominations_array){
                        if (record.reports_to_rom.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                    break;
            
                default:
                    break;
            }
            this.setState({filtered_assessments_array: temp_array, filter_applied:true});
        }
    }
    
    exportMe = () => {
        // console.log('called exportMe...');
        if (this.state.filtered_assessments_array.length>0){
            const dateStr = new moment().format("YYYY-MM-DD");
            var ws = XLSX.utils.json_to_sheet(this.state.filtered_assessments_array);
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Assessments Requ ' + dateStr);
            //Write to browser
            XLSX.writeFile(wb,'TMS Export - Assessments Required as at ' + dateStr + '.xlsx');
        }
    }
    
     render() {
        return (
            <Grid
                container
                direction='column'
                justifyContent='flex-start'
                alignContent='flex-start'
                // style={{backgroundColor:'yellow'}}
            >
                {!this.state.create_assessment&&
                <Grid item>
                <Paper
                    elevation={3}
                    style={{
                        // backgroundColor:'yellow',
                        width:1220
                    }}
                >

                    <Grid
                        container
                        justifyContent='center'
                        alignItems='center'
                        // style={{backgroundColor:'green'}}
                    >
                        <Grid item xs={4}>
                            <div style={{display:'flex', justifyContent:'space-evenly', alignItems:"center"}}>
                                {this.props.super_admin&&
                                <Toggle
                                    fieldMap={{field: "show_all", headerName: "Show All?", f_inputType:'toggle', f_true_tag:'Yes', f_false_tag:'No', f_show:true}} 
                                    editRecord={{show_all: this.state.show_all}}
                                    setField={this.handleToggleChange}
                                />}

                                <Tooltip title="Export to Excel">
                                <span>
                                <IconButton 
                                    aria-label='Export to Excel'
                                    onClick={this.exportMe}
                                    disabled={this.state.filtered_assessments_array.length===0}
                                >
                                    <ExcelLogo />
                                </IconButton>
                                </span>
                                </Tooltip>
                            </div>
                        </Grid>

                        <Grid item xs={4}>
                            <Typography style={{padding:'15px'}}>
                                Required Assessments
                            </Typography>
                        </Grid>
                        
                        <Grid item xs={4}>
                            <Grid 
                                container
                                alignItems='center'
                                justifyContent='space-evenly'
                                // style={{backgroundColor:'yellow'}}
                            >
                                <FilterBox
                                    setParentFilter={this.handleFilterChange}
                                    data_populated={this.state.nominations_array.length>0? true : false}
                                    filter_applied={this.state.filter_applied}
                                    filter_obj={this.state.filter_obj}
                                    show_hod_filter={this.props.super_admin}
                                    // show_branch_filter={true}
                                    // show_cycle_filter={true}
                                />
                            </Grid>
                        </Grid>
                        
                    </Grid>

                    {/* Datagrid goes here */}
                    <DatasheetView 
                        dataset={this.state.filtered_assessments_array}
                        fieldspecs={this.datasheetFieldSpecs}
                        delete={false}
                        edit={false}
                        handleDelete={null}
                        handleEdit={null}
                        loading={this.state.querying}
                        deleteHeaderName={'Delete'}
                        pagesize={10}
                        height={500}
                    />

                </Paper>
                </Grid>}

                {this.state.create_assessment&&this.state.assessment_type==='360'&&
                <AssessmentForm360 
                    assessment={this.state.assessment}
                    resetParentState={this.handleChildReset}
                    returnToParent={()=>this.setState({create_assessment:false})}
                    gwt={this.props.gwt}
                    rom={this.props.rom}
                    rom_code={this.props.rom_code}
                    super_admin={this.props.super_admin}
                    employee_number={this.props.employee_number}
                    employee_name={this.props.employee_name}
                />}

                {this.state.create_assessment&&this.state.assessment_type==='KPI'&&
                <AssessmentFormKPI
                    assessment={this.state.assessment}
                    resetParentState={this.handleChildReset}
                    returnToParent={()=>this.setState({create_assessment:false})}
                    gwt={this.props.gwt}
                    rom={this.props.rom}
                    rom_code={this.props.rom_code}
                    super_admin={this.props.super_admin}
                    employee_number={this.props.employee_number}
                    employee_name={this.props.employee_name}
                />}
 
                {this.state.create_assessment&&this.state.assessment_type==='PA'&&
                <AssessmentFormPA
                    assessment={this.state.assessment}
                    resetParentState={this.handleChildReset}
                    returnToParent={()=>this.setState({create_assessment:false})}
                    gwt={this.props.gwt}
                    rom={this.props.rom}
                    rom_code={this.props.rom_code}
                    super_admin={this.props.super_admin}
                    employee_number={this.props.employee_number}
                    employee_name={this.props.employee_name}
                />}
 
                {this.state.create_assessment&&this.state.assessment_type==='PSMA'&&
                <AssessmentFormPSMA
                    assessment={this.state.assessment}
                    resetParentState={this.handleChildReset}
                    returnToParent={()=>this.setState({create_assessment:false})}
                    gwt={this.props.gwt}
                    rom={this.props.rom}
                    rom_code={this.props.rom_code}
                    super_admin={this.props.super_admin}
                    employee_number={this.props.employee_number}
                    employee_name={this.props.employee_name}
                />}


                {this.state.create_assessment&&this.state.assessment_type==='PM'&&
                <AssessmentFormPM
                    assessment={this.state.assessment}
                    resetParentState={this.handleChildReset}
                    returnToParent={()=>this.setState({create_assessment:false})}
                    gwt={this.props.gwt}
                    rom={this.props.rom}
                    rom_code={this.props.rom_code}
                    admin={this.props.admin}
                    super_admin={this.props.super_admin}
                    employee_number={this.props.employee_number}
                    employee_name={this.props.employee_name}
                />}
 
                {this.state.create_assessment&&this.state.assessment_type==='CA'&&
                <AssessmentFormCA
                    assessment={this.state.assessment}
                    resetParentState={this.handleChildReset}
                    returnToParent={()=>this.setState({create_assessment:false})}
                    gwt={this.props.gwt}
                    rom={this.props.rom}
                    rom_code={this.props.rom_code}
                    admin={this.props.admin}
                    super_admin={this.props.super_admin}
                    employee_number={this.props.employee_number}
                    employee_name={this.props.employee_name}
                />}

                <Grid item>
                    <Typography color='secondary' style={{Width:1220,maxWidth:1220, textAlign:'center'}}>{this.state.error_message}</Typography>
                    {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
                </Grid>

            </Grid>
        );
    }
    
}